import { render } from "./CreateOrUpdateQuizQuestionModal.vue?vue&type=template&id=2dc7c311"
import script from "./CreateOrUpdateQuizQuestionModal.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateQuizQuestionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__